export default "__VITE_ASSET__DBRonkct__"